import { useRef } from 'react';

export const useTrackDuration = () => {
  const eventStartTime = useRef(0);

  const startTimer = () => (eventStartTime.current = Date.now());
  const getDuration = () => Date.now() - eventStartTime.current;

  return {
    startTimer,
    getDuration
  };
};
